import React from 'react';
import { Box } from '@chakra-ui/react';
import VersionDisplay from 'components/version/VersionDisplay';

export default function SidebarDocs() {
  return (
    <Box mt="auto" pt={4}>
      <VersionDisplay align="center" />
    </Box>
  );
}
